var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4, _path5, _path6, _path7, _path8, _rect5, _rect6, _polygon, _rect7, _rect8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon2, _polygon3, _path29, _path30, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path31, _rect18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineShopping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 417.98 401.07",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 214.4,
    y1: 209.18,
    x2: 213.45,
    y2: 449.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -29.06,
    y1: 290.81,
    x2: 271.34,
    y2: 103.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 233.04,
    y1: 143.05,
    x2: 215.88,
    y2: 222.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 296.3,
    y1: 334.3,
    x2: 321.09,
    y2: 192.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 418.02,
    y1: 275.44,
    x2: 253.04,
    y2: 251.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 378.23,
    y1: 317.23,
    x2: 336.27,
    y2: 227.27,
    gradientTransform: "translate(-58.97 106.39) rotate(-15.78)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 7184.73,
    y1: 216.54,
    x2: 7177.58,
    y2: 204.38,
    gradientTransform: "matrix(-1, 0, 0, 1, 7416.35, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 7218.32,
    y1: 266.34,
    x2: 7228.56,
    y2: 266.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 7416.35, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 7260.58,
    y1: 217.9,
    x2: 7164.48,
    y2: 212.48,
    gradientTransform: "matrix(-1, 0, 0, 1, 7416.35, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 7172.3,
    y1: 350.3,
    x2: 7190.19,
    y2: 350.3,
    gradientTransform: "matrix(-1, 0, 0, 1, 7416.35, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 7233.66,
    y1: 350.09,
    x2: 7245.13,
    y2: 350.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 7416.35, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 7218.48,
    y1: 233.39,
    x2: 7203.46,
    y2: 204.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 7416.35, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 143.69,
    y1: 307.19,
    x2: 143.34,
    y2: 393.52,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shopping online") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.85,341.33c-.5,1-1,1.94-1.5,2.9-6.65,12.51-15.34,24.69-28,31-16.7,8.38-36.6,5-55,1.89-34.28-5.81-69.37-10.06-103.72-4.68-51.35,8-100.86,37.43-152,28.3a104.77,104.77,0,0,1-48.82-22.86c-5.27-4.44-10.18-9.5-13.3-15.64C9.17,355.83,8,348.56,7.54,341.33c0-.57-.08-1.15-.1-1.71a144.3,144.3,0,0,1,13.18-67.69C28.9,254.09,41,237.5,44,218.07c4-25.71-8.67-51.32-7.88-77.32A76.7,76.7,0,0,1,73.48,78C89,69,107.27,65.77,123.9,58.87A120.33,120.33,0,0,0,158.38,37c8.19-7.36,14.11-18.42,23.13-24.61,16.27-11.14,47.8-15,65.2-6,9.65,5,16.72,13.7,24.32,21.47,19.77,20.18,44.33,34.89,66.6,52.28s43.13,38.85,50.81,66c7.83,27.66,1.08,58,9.6,85.42,7.2,23.23,25,43.1,27,67.34C426.28,313.65,421.49,328.14,414.85,341.33Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#68e1fd",
    opacity: 0.41
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.85,341.33c-.5,1-1,1.94-1.5,2.9-6.65,12.51-15.34,24.69-28,31-16.7,8.38-36.6,5-55,1.89-34.28-5.81-69.37-10.06-103.72-4.68-51.35,8-100.86,37.43-152,28.3a104.77,104.77,0,0,1-48.82-22.86c-5.27-4.44-10.18-9.5-13.3-15.64C9.17,355.83,8,348.56,7.54,341.33Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#68e1fd",
    opacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.67,369.05c4.27,4.81,11.34,5.71,17.76,6.18a571,571,0,0,0,90-.48c11-.93,22.05-2.19,32.95-4.13,13.23-2.36,26.3-5.74,39.67-7.05,41.85-4.1,84.45,12.18,125.63,3.67,4.75-1,10.2-3,11.41-7.72,1.07-4.11-1.94-8.4-5.77-10.25s-8.25-1.84-12.5-1.8c-87.63.76-175.26,1.86-262.89,2.28-7,0-14.55-.87-21.25,1.57C65.1,353.36,49.48,362.09,55.67,369.05Z",
    transform: "translate(-7.26 -1.43)",
    fill: "url(#linear-gradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.13,
    y: 49.98,
    width: 113.48,
    height: 307.08,
    rx: 23.69,
    fill: "#68e1fd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.13,
    y: 49.98,
    width: 113.48,
    height: 307.08,
    rx: 23.69,
    fill: "url(#linear-gradient-2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.58,
    y: 49.98,
    width: 142.72,
    height: 307.08,
    rx: 26.57,
    fill: "#68e1fd"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82.27,
    y: 73.11,
    width: 121.59,
    height: 260.35,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.32,285.5l.42,58.23-6.14.58s-7.95-25.43-7-29.25,3-12.87,3-12.87-6-11.44-5.8-15a12,12,0,0,1,2.39-6.2Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#f3bd8f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.73,285.5s0,9.22-.95,11.44-26.39,42.6-26.39,42.6l-3.74-3.26s6.92-28.21,12-33.93l5.08-5.72.78-12.25Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#f3bd8f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.58,144.39c-.24-2.7-1.33-5.14-.8-8,.9-4.89,5.5-8.49,10.37-9.49s9.94.14,14.63,1.8a25.39,25.39,0,0,1,8.6,4.66c6.19,5.56,6.92,14.78,9.33,22.75.94,3.09,2.32,6.26,5,8.11,3.51,2.46,8.24,2,12.32,3.28a14.77,14.77,0,0,1,9.91,11.73c.67,4.73-.85,10.22,2.22,13.88,1.6,1.91,4.19,2.88,5.53,5a10.6,10.6,0,0,1,1.27,3.85c.77,4.1,1,9.13-2.33,11.6a11,11,0,0,1-5.58,1.6c-4.77.42-9.69.43-14.21-1.12-4.06-1.4-7.59-4-11.05-6.52-7.1-5.23-14.23-10.48-20.64-16.54-4-3.77-7.74-7.67-12-11.14-2.85-2.32-5-6.29-7.83-8.28-1.46-1-3.24-1-4.68-2.36a9.62,9.62,0,0,1-2.45-4c-1.07-3.47-.46-7.21.42-10.72.75-3,2.22-6.51,2-9.64Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#3e3e54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.67,150.23a75.57,75.57,0,0,1,3.33,10c1,3.37,2.36,6.74,4.73,9.35a41.72,41.72,0,0,1,3.58,3.83c2.17,3.15,1.92,7.45.58,11-.66,1.75-1.82,3.61-3.67,3.9s-3.38-1-4.71-2.24l-14.27-13a25,25,0,0,1-5.14-5.74c-1.85-3.21-2.17-7.11-1.76-10.8a19.62,19.62,0,0,1,3-9c1.38-2,4.87-5.59,7.62-4.8C226,143.68,228.45,147.64,229.67,150.23Z",
    transform: "translate(-7.26 -1.43)",
    fill: "url(#linear-gradient-3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.16,228.41l34.1-.45,12.51,38.77,15.15,53.39H268.11ZM282.72,268l-11.53-35.73-25.33.34,25.38,83.32h25.07Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#68e1fd"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 282.32,
    y: 212.7,
    width: 53.4,
    height: 97.27,
    fill: "#68e1fd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 282.32,
    y: 212.7,
    width: 53.4,
    height: 97.27,
    fill: "url(#linear-gradient-4)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "325 212.94 325 241.79 305.69 309.5 331.91 309.5 337.64 288.99 335.73 212.7 325 212.94",
    fill: "url(#linear-gradient-5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 332.5,
    y: 226.34,
    width: 43.56,
    height: 79.35,
    transform: "translate(78.45 -87.77) rotate(15.78)",
    fill: "#68e1fd"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 332.5,
    y: 226.22,
    width: 43.56,
    height: 79.35,
    transform: "translate(78.42 -87.77) rotate(15.78)",
    fill: "url(#linear-gradient-6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M293.12,348.54a7.19,7.19,0,0,1,11.93-8h0a7.19,7.19,0,1,1-11.93,8Zm8.42-5.65a3,3,0,1,0-.81,4.09,3,3,0,0,0,.81-4.09Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#2e2e3f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M345.79,348.54a7.19,7.19,0,0,1,11.94-8h0a7.19,7.19,0,0,1-11.94,8Zm8.42-5.65a3,3,0,1,0-.8,4.09,3,3,0,0,0,.8-4.09Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#2e2e3f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M240.33,202.47a9.59,9.59,0,0,0,1.1,2.36,9.33,9.33,0,0,0,3.52,2.6c5.36,2.76,13.57,5.72,18.09,9.7a5,5,0,0,1,1.35,1.61c.65,1.41,0,3-.6,4.47a4.81,4.81,0,0,1-1.39,2.08c-1.16.84-2.77.48-4.14.07a154,154,0,0,1-15.61-5.56,68,68,0,0,1-8.28-4,6.24,6.24,0,0,1-3.71-5.13,126.07,126.07,0,0,1-1.94-15.52l-1-12.25c-.19-2.36-7.36-10.59-5.2-12.22,4.22-3.17,10.38,5.46,11.35,7.23C236.58,182.89,239.27,199.45,240.33,202.47Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#68e1fd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M240.33,202.47a9.59,9.59,0,0,0,1.1,2.36,9.33,9.33,0,0,0,3.52,2.6c5.36,2.76,13.57,5.72,18.09,9.7a5,5,0,0,1,1.35,1.61c.65,1.41,0,3-.6,4.47a4.81,4.81,0,0,1-1.39,2.08c-1.16.84-2.77.48-4.14.07a154,154,0,0,1-15.61-5.56,68,68,0,0,1-8.28-4,6.24,6.24,0,0,1-3.71-5.13,126.07,126.07,0,0,1-1.94-15.52l-1-12.25c-.19-2.36-7.36-10.59-5.2-12.22,4.22-3.17,10.38,5.46,11.35,7.23C236.58,182.89,239.27,199.45,240.33,202.47Z",
    transform: "translate(-7.26 -1.43)",
    fill: "url(#linear-gradient-7)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M237,281.34a4.55,4.55,0,0,1-.7,2.82,4.25,4.25,0,0,1-2.08,1.16c-4,1.26-38,2.54-44.35,1.36-2.47-9.12-2.56-18.76-1.32-28.13.49-3.65,1.21-7.37,3.14-10.5a6.2,6.2,0,0,1,2-2.13,7.7,7.7,0,0,1,3.93-.73c9.8-.1,19.77-.33,29.51,1.06,3,.43,4.63,1.38,5.69,4.35A75.52,75.52,0,0,1,236,265,103.33,103.33,0,0,1,237,281.34Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#2e2e3f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M189.89,286.68l1.52.26a12.25,12.25,0,0,0,1.06-.62,5.7,5.7,0,0,0,2.05-1.94,6,6,0,0,0,.52-2.63c.28-7.55-1.16-15.22.38-22.62.55-2.66,1.65-5.06,2.43-7.62.72-2.34-.88-3.74-2.77-5.11a6.41,6.41,0,0,0-1.06-.65l-.34.17a6,6,0,0,0-2,2.13c-1.94,3.13-2.66,6.85-3.15,10.5C187.33,267.91,187.41,277.56,189.89,286.68Z",
    transform: "translate(-7.26 -1.43)",
    fill: "url(#linear-gradient-8)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214,163.46a6.26,6.26,0,0,0,1.7,4.1c1.56,1.4,3.93,1.32,5.87,2.1a1.72,1.72,0,0,1,.66.41,1.5,1.5,0,0,1,.3.59,5.06,5.06,0,0,1-.23,3.07,10.8,10.8,0,0,1-6.69,6.18,20.29,20.29,0,0,1-9.3.65,6.9,6.9,0,0,1-3-.89,7.18,7.18,0,0,1-2.22-2.79,8.88,8.88,0,0,1-1.19-3.28,3.41,3.41,0,0,1,1.23-3.12,6.09,6.09,0,0,1,1.37-.63,12.86,12.86,0,0,0,2.16-1.09,3.26,3.26,0,0,0,1.54-1.68,4.23,4.23,0,0,0-.08-1.87,17.17,17.17,0,0,1,0-6.23,5.69,5.69,0,0,1,.56-1.75,3.52,3.52,0,0,1,5.5-.86C214.15,158.19,213.73,161.07,214,163.46Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#f3bd8f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M223.33,152.48a12.5,12.5,0,0,1-.35,4.18c-1,3.24-4.43,5.33-7.82,5.47a6.27,6.27,0,0,1-3.23-.61,8.34,8.34,0,0,1-1.58-1.2c-2.37-2.17-4.55-4.76-5.27-7.89a15.11,15.11,0,0,1-.31-3.62,14.26,14.26,0,0,1,.9-5.23A9.34,9.34,0,0,1,213,138c3.29-.42,6.36,1.24,8.76,3.3,1.2,1,1,3.07,1.17,4.61C223.11,148.1,223.26,150.29,223.33,152.48Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#f3bd8f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M192.22,248.82a12.27,12.27,0,0,0,5.08,2,67.74,67.74,0,0,0,29.53-.05c2-.47,4.29-1.21,5.17-3.11a7.21,7.21,0,0,0,.44-3.27q-.34-15.69-.7-31.4c-.26-11.9-.52-23.84-2.27-35.61a20,20,0,0,0-2.84-6.82c-1.14-1.55-6.28-.72-10.57-3.5-1.18-.76,1.38,3.18-2.47,4.81s-8.44-6.25-10.88-3.07c-1.37,1.78-5.7.46-7.07,2.23-1.1,1.42-1.78,4.43-2.21,8.05-.92,7.7-.69,18.15-.89,21.95-.72,13.3.4,30.27-4,41.26C187.6,244.67,190.23,247.25,192.22,248.82Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#68e1fd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M192.22,248.82a12.27,12.27,0,0,0,5.08,2,68,68,0,0,0,7.36,1.21l.7-.09c-1.81-5.9-1.9-12.16-1.85-18.33q.06-5.1.17-10.22c0-2.15.12-4.41,1.23-6.25s3.63-3,5.48-1.89c-3.18-1.92-5.78-10-7.08-13.33A66.89,66.89,0,0,1,199.4,187c-.5-3.5-.31-9.67-5.68-8l-.29.1c-.92,7.7-.69,18.15-.89,21.95-.72,13.3.4,30.27-4,41.26C187.6,244.67,190.23,247.25,192.22,248.82Z",
    transform: "translate(-7.26 -1.43)",
    fill: "url(#linear-gradient-9)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M228.2,343.64a1.23,1.23,0,0,0-.8.4,1.43,1.43,0,0,0-.14.8c0,1.68-1.08,3.23-1,4.9,0,1.51,1,2.91.85,4.41,0,.3-.08.64.13.85a.94.94,0,0,0,.49.21q6.38,1.21,12.81,2.13a3.34,3.34,0,0,0,2.36-.26,2.44,2.44,0,0,0,.75-1c1.16-2.37.13-5.26-1.44-7.37C238.33,343.59,234.61,342.35,228.2,343.64Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#2e2e3f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.05,343.38a5.87,5.87,0,0,0,2.17,3.41,34.59,34.59,0,0,0,9.22,6.09,3.92,3.92,0,0,0,2.25.48,2.82,2.82,0,0,0,2-2.74,8.18,8.18,0,0,0-.94-3.52c-1.63-3.78-2.77-9.33-7.13-10.82C172.84,335,168.64,339.62,169.05,343.38Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#2e2e3f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.12,343.64a1.23,1.23,0,0,0-.8.4,1.43,1.43,0,0,0-.14.8c0,1.68-1.08,3.23-1,4.9.05,1.51,1,2.91.85,4.41,0,.3-.08.64.13.85a.94.94,0,0,0,.49.21q6.38,1.21,12.81,2.13a3.34,3.34,0,0,0,2.36-.26,2.44,2.44,0,0,0,.75-1c1.16-2.37.13-5.26-1.44-7.37C238.25,343.59,234.53,342.35,228.12,343.64Z",
    transform: "translate(-7.26 -1.43)",
    fill: "url(#linear-gradient-10)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.22,346.79a34.59,34.59,0,0,0,9.22,6.09,3.92,3.92,0,0,0,2.25.48",
    transform: "translate(-7.26 -1.43)",
    fill: "url(#linear-gradient-11)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M200.52,201.56a6.69,6.69,0,0,0,.33,3.15c.61,1.4,2,2.24,3.36,3l30,17c1.41.8,2.91,1.7,3.51,3.21,1.32,3.35-2.82,6.42-6.41,6.69-3.77.28-7.49-.86-11.06-2.09a193.36,193.36,0,0,1-32.56-14.73,5.85,5.85,0,0,1-3.73-6.5,155.53,155.53,0,0,1,1.9-24.76c.71-4.48,1.72-9.15,4.72-12.56,4.46-5.06,12.63-5.22,13.33,2.22C204.75,184.57,201.09,193.21,200.52,201.56Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#68e1fd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M200.52,201.56a6.69,6.69,0,0,0,.33,3.15c.61,1.4,2,2.24,3.36,3l30,17c1.41.8,2.91,1.7,3.51,3.21,1.32,3.35-2.82,6.42-6.41,6.69-3.77.28-7.49-.86-11.06-2.09a193.36,193.36,0,0,1-32.56-14.73,5.85,5.85,0,0,1-3.73-6.5,155.53,155.53,0,0,1,1.9-24.76c.71-4.48,1.72-9.15,4.72-12.56,4.46-5.06,12.63-5.22,13.33,2.22C204.75,184.57,201.09,193.21,200.52,201.56Z",
    transform: "translate(-7.26 -1.43)",
    fill: "url(#linear-gradient-12)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M241.65,227.49a8.58,8.58,0,0,1,5.84,2.29,5.21,5.21,0,0,1,1.1,5.91,2.87,2.87,0,0,1-1.57,1.42,3.09,3.09,0,0,1-1.83-.06c-1.72-.51-3.09-1.83-4.75-2.5a1.9,1.9,0,0,0-1.3-.15,5,5,0,0,0-.79.5,2.5,2.5,0,0,1-2.29.08,4.24,4.24,0,0,1-1.74-1.57,4.49,4.49,0,0,1-.83-2.93c.17-1.61,1.1-2.12,2.49-2.29A37.07,37.07,0,0,1,241.65,227.49Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#f3bd8f"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M269.55,222.27a7.81,7.81,0,0,1,1.6,3.42,3.46,3.46,0,0,1-.06,1.78,3.07,3.07,0,0,1-2.91,1.84,7.2,7.2,0,0,1-3.46-1.07,46.08,46.08,0,0,1-5.53-3.77,4.79,4.79,0,0,1-1-.89,2.74,2.74,0,0,1,.44-3.39C261.53,217.29,267.4,219.6,269.55,222.27Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#f3bd8f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M275.22,244.63H395.76L368.07,320.1H296.7Zm114.48,4.23H280.82l19.07,67h65.22Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#68e1fd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M245,244.63H367.6L339.9,320.1H268.53Zm116.55,4.23H252.66l19.07,67H337Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#68e1fd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.92 339.77 343.67 339.77 343.67 335.54 265.16 335.54 265.16 316.55 260.92 316.55 260.92 339.77",
    fill: "#68e1fd"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "288.62 339.77 355.99 339.77 355.99 335.54 292.85 335.54 292.85 316.55 288.62 316.55 288.62 339.77",
    fill: "#68e1fd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M274.64,344.53a7.19,7.19,0,1,1,7.18,7.19A7.2,7.2,0,0,1,274.64,344.53Zm4.23,0a3,3,0,1,0,2.95-2.95A3,3,0,0,0,278.87,344.53Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#2e2e3f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M327.21,348.54a7.19,7.19,0,0,1,11.93-8h0a7.19,7.19,0,1,1-11.93,8Zm8.42-5.65a3,3,0,1,0-.81,4.09,3,3,0,0,0,.81-4.09Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#2e2e3f"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 245.2,
    y: 258.32,
    width: 133.83,
    height: 3.19,
    fill: "#68e1fd"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 248.69,
    y: 269.05,
    width: 127.47,
    height: 3.19,
    fill: "#68e1fd"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 252.19,
    y: 279.78,
    width: 119.84,
    height: 3.19,
    fill: "#68e1fd"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 255.69,
    y: 290.51,
    width: 112.21,
    height: 3.19,
    fill: "#68e1fd"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 259.18,
    y: 301.23,
    width: 104.58,
    height: 3.19,
    fill: "#68e1fd"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 328.86,
    y: 280.1,
    width: 75.12,
    height: 3.19,
    transform: "translate(-31.07 527.93) rotate(-69.96)",
    fill: "#68e1fd"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 295.56,
    y: 279.62,
    width: 72.57,
    height: 3.19,
    transform: "translate(-38.93 518.66) rotate(-73.59)",
    fill: "#68e1fd"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 274.13,
    y: 279.38,
    width: 71.09,
    height: 3.19,
    transform: "translate(11.21 579.62) rotate(-88.08)",
    fill: "#68e1fd"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 280.19,
    y: 246.22,
    width: 3.19,
    height: 72.85,
    transform: "translate(-77.98 94.04) rotate(-17.12)",
    fill: "#68e1fd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M216.7,141.73c2.68,1.6,6,1.27,9.14.88a8.19,8.19,0,0,0-2.65-4.8,11.1,11.1,0,0,0-3.44-2.26c-1.75-.71-6.4-1.62-7.55.57C211.26,137.91,215.35,140.93,216.7,141.73Z",
    transform: "translate(-7.26 -1.43)",
    fill: "#3e3e54"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 129.39,
    y: 338.62,
    width: 28.29,
    height: 10.81,
    rx: 5.4,
    fill: "url(#linear-gradient-13)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineShopping);
export default __webpack_public_path__ + "static/media/online-shopping.e747db0e8851af5a89ce09092aafbd35.svg";
export { ForwardRef as ReactComponent };